@let marketAreas = marketAreas$ | async;
@let parserTypes = parserTypes$ | async;

<cc-dashboard-page-container>
  <ng-container title> {{ 'sidebar.raw-data.TITLE' | transloco }}</ng-container>
  @if (isLoading$ | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <div class="flex mt-6 gap-6 w-2/3 mb-6">
    <!-- CATEGORY -->

    <mat-form-field>
      <mat-label
      >{{
          'raw-data.filters.PRODUCT_GROUP' | transloco
        }}
      </mat-label>
      <mat-select
        [formControl]="identifierCategoriesFormControl"
        [disabled]="isLoading$ | async"
      >
        @for (i of timeSeriesIdentifierCategoriesLocalized$ | async;
          track i.id) {
          <mat-option [value]="i">{{ i.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- DATE RANGE -->
    <mat-form-field (click)="picker.open()">
      <mat-label>
        {{
          'raw-data.filters.DATE_RANGE' | transloco
        }}
      </mat-label>
      <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
        <input
          matStartDate
          formControlName="start"
          placeholder="{{
          'raw-data.filters.options.FROM' | transloco
        }}"
          readonly
        />
        <input
          matEndDate
          formControlName="end"
          placeholder="{{
          'raw-data.filters.options.TO' | transloco
        }}"
          readonly
        />
      </mat-date-range-input>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <!-- AREA MARKET AREA -->
    <mat-form-field>
      <mat-label>
        {{
          'raw-data.filters.MARKET_AREA' | transloco
        }}
      </mat-label>
      <mat-select [formControl]="marketAreaFormControl">
        @if (marketAreas) {
          <mat-option [value]="null">
            {{
              'raw-data.filters.options.NO_SELECTION' | transloco
            }}
          </mat-option>

          @for (i of marketAreas; track i.id) {
            @if (i.id === null) {
              <mat-option [value]="-1">
                {{
                  'raw-data.filters.options.WITHOUT_MARKET_AREA' | transloco
                }}
              </mat-option>
            } @else {
              <mat-option [value]="i.id">{{ i.name }}</mat-option>
            }
          }
        }
      </mat-select>
    </mat-form-field>

    <!-- TYPE -->
    <mat-form-field>
      <mat-label>Typ</mat-label>
      <mat-select [formControl]="typeFormControl">
        <mat-option [value]="null">
          {{
            'raw-data.filters.options.NO_SELECTION' | transloco
          }}
        </mat-option>
        @for (i of parserTypes; track i.name) {
          <mat-option [value]="i.name">{{ i.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <cc-add-action-button (onClick)="onAddClick($event)"></cc-add-action-button>
  </div>
  <!-- TABLE -->
  <dx-pivot-grid
    id="sales"
    [stateStoring]="{ enabled: true }"
    [allowSortingBySummary]="true"
    [allowSorting]="true"
    [allowFiltering]="true"
    [allowExpandAll]="true"
    height="70%"
    width="100%"
    [showBorders]="true"
    [hideEmptySummaryCells]="true"
    [dataSource]="dataSource$ | async"
    [showTotalsPrior]="pivotGridTotalDisplayMode"
    [showColumnGrandTotals]="false"
    [showRowGrandTotals]="false"
    [showRowTotals]="false"
    [showColumnTotals]="false"
    [loadPanel]="{ enabled: false }"
    [visible]="
      (isLoading$ | async) === false &&
      identifierCategoriesFormControl.value !== null
    "
    (onCellClick)="onCellClick($event)"
    (onCellPrepared)="onCellPrepared($event)"
    (onContentReady)="onContentReady($event)"
  >
    <!-- (onCellClick)="editCellPopup.onCellClick($event, dataSource)"
        (onInitialized)="onInitialized()" -->
    >
    <dxo-field-chooser
      [enabled]="true"
      [applyChangesMode]="'onDemand'"
      [allowSearch]="true"
    ></dxo-field-chooser>
  </dx-pivot-grid>

  @if ((isLoading$ | async) === false &&
  identifierCategoriesFormControl.value !== null) {
    <div class="flex gap-8 place-content-center mt-8">
      <div class="flex gap-4 items-center">
        <div class="h-3 w-12" style="background-color: #06d6a0"></div>
        <div>
          {{
            'raw-data.legend.INTRADAY' | transloco
          }}
        </div>
      </div>

      <div class="flex gap-4 items-center">
        <div class="h-3 w-12" style="background-color: #48cae4"></div>
        <div>
          {{
            'raw-data.legend.EDITED' | transloco
          }}
        </div>
      </div>
      <div class="flex gap-4 items-center">
        <div class="h-3 w-12" style="background-color: #f4a261"></div>
        <div>
          {{
            'raw-data.legend.INTRADAY_AND_EDITED' | transloco
          }}
        </div>
      </div>
      <div class="flex gap-4 items-center">
        <div class="h-3 w-12" style="background-color: #f25c54"></div>
        <div>
          {{
            'raw-data.legend.DUPLICATE_DATA' | transloco
          }}
        </div>
      </div>
    </div>
  }
</cc-dashboard-page-container>
